import { post, put } from 'services/api';
import { AddonOrderItem } from './types';

export const getApplicableAddons = async (eventId: number, ticketTypeIds: number[]) => {
	const ticketTypes: Record<string, number> = {};
	ticketTypeIds.forEach((id) => {
		ticketTypes[id.toString()] = 1;
	});

	return post('/public/ticketing/addons/applicable', {
		event_id: eventId,
		ticket_types: ticketTypes,
	});
};

export const reorderAddonsPut = async (addons: AddonOrderItem[]) => {
	return put(
		'/addons/reorder',
		addons.map(({ iD, orderIndex }) => ({ ID: iD, order_index: orderIndex }))
	);
};
